import { idGenerator } from '@/services'

export interface WorkFileTrackingState {
  requestId: string,
}

export const InitialState: WorkFileTrackingState = {
  requestId: idGenerator.getNewWebReference(),
}
